import { selectStandardProps } from "@/utils/componentUtils";
import { Select } from "antd";
import { useEnumeration } from "../../../../common/api/queries";
import type { UUID } from "../../../../typings/global";
import { EnumerationType } from "../../enums";

type Props<T extends boolean> = {
  value?: T extends true ? UUID[] : UUID;
  allowClear?: boolean;
  isMultiple?: T;
  onChange?: (data: T extends true ? UUID[] : UUID) => void;
  disabled?: boolean;
};

export const LifeInsuranceTariffGroupSelect = <T extends boolean>({
  value,
  allowClear,
  isMultiple,
  onChange,
  disabled,
}: Props<T>) => {
  const tariffGroupsEnums = useEnumeration(EnumerationType.TARIFF_GROUPS);

  return (
    <Select
      {...selectStandardProps}
      allowClear={allowClear}
      disabled={disabled}
      maxTagCount="responsive"
      mode={isMultiple ? "multiple" : undefined}
      options={tariffGroupsEnums.map((group) => ({ value: group.id, label: group.name }))}
      onChange={onChange}
      value={value}
    />
  );
};
